// src/utils/letterhead.js — invhead-2d7c5b94 (R1d-3 polish)
// HAND-SYNCED MIRROR of functions/utils/letterhead.js — THE business address on customer documents:
// street, unit, then "City, Province Postal". The in-app invoice screen's header uses this copy so
// it reads like the invoice PDF (it used to skip the unit line and put the postal code on its own
// line). Everything below this header is identical to the server file apart from the export line;
// invoiceRefundStatus.test.js compares them. Change both together.

const clean = (v) => String(v === undefined || v === null ? '' : v).trim();

/** "City, Province Postal" (any part may be missing), or ''. */
function cityLine(org) {
  const o = org || {};
  const region = [clean(o.state), clean(o.zip)].filter(Boolean).join(' ');
  return [clean(o.city), region].filter(Boolean).join(', ');
}

/** Every address line, in order: street, unit, city line. */
function addressLines(org) {
  const o = org || {};
  return [clean(o.address1), clean(o.address2), cityLine(o)].filter(Boolean);
}

/**
 * The lines the invoice / estimate PDFs ADD below their existing address1 line (which they keep
 * printing exactly as before): unit, then the city line.
 */
function addressLinesAfterStreet(org) {
  const o = org || {};
  return [clean(o.address2), cityLine(o)].filter(Boolean);
}

export { addressLines, addressLinesAfterStreet, cityLine };
